// import React from 'react';
// import { motion } from 'framer-motion';

// // ==============================
// // Utility Helpers
// // ==============================
// const uid = (prefix = '') => `${prefix}${Math.random().toString(36).slice(2, 9)}`;

// // ==============================
// // Certification Data
// // ==============================
// const certifications = [
//   { 
//     id: uid('cert_'), 
//     name: 'Data Science Mega-Course: #Build {120-Projects In 120-Days}', 
//     issuer: 'Udemy', 
//     year: 'Feb,2024', 
//     tags: ['Machine-learning', 'Data-science'],
//     filePath: '/pictures/certifications/1-datascience mega course.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'Build Generative AI Apps and Solutions with No-Code Tools', 
//     issuer: 'Udemy', 
//     year: 'Sept,2025', 
//     tags: ['AI', 'No-Code', 'Generative AI'],
//     filePath: '/pictures/certifications/2-Build Generative Al Apps and Solutions with No-Code.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'The Bits and Bytes of Computer Networking', 
//     issuer: 'Coursera - Google', 
//     year: 'Sept,2023', 
//     tags: ['Computer-Networks', 'Architecture'],
//     filePath: '/pictures/certifications/3-bits and bytes.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'TCP/IP and Advanced Topics', 
//     issuer: 'Coursera', 
//     year: 'Nov,2024', 
//     tags: ['Cloud', 'Fundamentals'],
//     filePath: '/pictures/certifications/4-TCP-IP.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'Fundamentals of Network Communication', 
//     issuer: 'Coursera', 
//     year: 'Sep,2024', 
//     tags: ['ML', 'Deep Learning'],
//     filePath: '/pictures/certifications/5-Fundamentals of Network Communication.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'Packet Switching Networks and Algorithms', 
//     issuer: 'Coursera', 
//     year: 'Nov,2024', 
//     tags: ['Frontend', 'React'],
//     filePath: '/pictures/certifications/6-packet switching.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'Digital Systems- From Logic Gates to Processors', 
//     issuer: 'Coursera', 
//     year: 'Nov,2024', 
//     tags: ['Programming', 'Python'],
//     filePath: '/pictures/certifications/7-Digital Systems- From Logic Gates to Processors.pdf'
//   },
//   { 
//     id: uid('cert_'), 
//     name: 'Peer-to-Peer Protocols and Local Area Networks.pdf', 
//     issuer: 'coursera', 
//     year: 'Nov,2024', 
//     tags: ['ML', 'AI'],
//     filePath: '/pictures/certifications/8-Peer-to-Peer Protocols and Local Area Networks.pdf'
//   }
// ];

// // ==============================
// // Main Certifications Component
// // ==============================
// const Certifications = () => {
//   // Function to handle opening the new page
//   const handleViewMore = () => {
//     // Open the new page in the same window
//     window.location.href = '/more-certifications';
//   };

//   return (
//     <div className="relative min-h-screen py-12 px-4 sm:px-6 lg:px-8 overflow-hidden">
//       {/* Animated Background Elements */}
//       <motion.div 
//         className="absolute inset-0 bg-gradient-to-b from-gray-900 via-gray-800 to-black opacity-95"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         transition={{ duration: 1 }}
//       />
      
//       <motion.div 
//         className="absolute top-10 left-10 w-64 h-64 bg-primary-cyan/10 rounded-full blur-3xl"
//         animate={{ 
//           x: [0, 20, 0],
//           y: [0, -20, 0],
//           scale: [1, 1.1, 1]
//         }}
//         transition={{ 
//           duration: 15,
//           repeat: Infinity,
//           repeatType: "reverse"
//         }}
//       />
      
//       <motion.div 
//         className="absolute bottom-20 right-20 w-72 h-72 bg-purple-500/10 rounded-full blur-3xl"
//         animate={{ 
//           x: [0, -30, 0],
//           y: [0, 30, 0],
//           scale: [1, 1.2, 1]
//         }}
//         transition={{ 
//           duration: 20,
//           repeat: Infinity,
//           repeatType: "reverse"
//         }}
//       />
      
//       <motion.div 
//         className="absolute top-1/3 right-1/4 w-40 h-40 bg-blue-400/10 rounded-full blur-3xl"
//         animate={{ 
//           x: [0, 40, 0],
//           y: [0, 40, 0],
//         }}
//         transition={{ 
//           duration: 12,
//           repeat: Infinity,
//           repeatType: "reverse"
//         }}
//       />

//       <div className="max-w-7xl mx-auto relative z-10">
//         <motion.header 
//           className="text-center mb-12"
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//         > 
//           <motion.div
//             className="rounded-2xl backdrop-blur-lg border border-gray-700 p-6 bg-transparent"
//           >
//             <h1 className="text-4xl md:text-5xl font-bold text-white mb-2">
//               <span className="bg-gradient-to-r from-primary-cyan to-blue-400 bg-clip-text text-transparent">Professional Certifications</span>
//             </h1>
//             <p className="text-lg text-gray-300 max-w-3xl mx-auto">
//               My verified certifications and continuous learning journey in technology.
//             </p>
//           </motion.div>
//         </motion.header>

//         <motion.main 
//           initial={{ opacity: 0, y: 14 }} 
//           animate={{ opacity: 1, y: 0 }} 
//           transition={{ duration: 0.45 }}
//         >
//           <div className="grid grid-cols-1 gap-6">
//             <motion.div 
//               className="rounded-2xl p-6 bg-gradient-to-br from-gray-800/40 to-gray-900/30 backdrop-blur-lg border border-gray-700"
//               initial={{ opacity: 0, x: -20 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.5 }}
//             >
//               <h3 className="text-lg font-bold text-white">Certifications</h3>
//               <p className="text-gray-400 mt-1">Verified certifications and credentials.</p>

//               <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//                 {certifications.map((cert) => (
//                   <motion.div 
//                     key={cert.id} 
//                     className="rounded-lg p-4 bg-white/3 backdrop-blur-sm border border-white/5 hover:border-primary-cyan/30 transition-colors h-56 flex flex-col justify-between"
//                     whileHover={{ y: -3 }}
//                     transition={{ duration: 0.2 }}
//                   >
//                     <div className="flex items-start justify-between">
//                       <div>
//                         <div className="text-sm text-gray-300">{cert.issuer} • {cert.year}</div>
//                         <div className="text-lg font-semibold text-white mt-1">{cert.name}</div>
//                         <div className="flex gap-2 mt-2 flex-wrap">
//                           {cert.tags.map((tag, i) => (
//                             <span key={i} className="text-xs px-2 py-1 bg-primary-cyan/10 text-primary-cyan rounded-full">
//                               {tag}
//                             </span>
//                           ))}
//                         </div>
//                       </div>
//                       <div className="flex flex-col items-end gap-3">
//                         <div className="text-xs bg-green-900/30 text-green-400 px-2 py-1 rounded">Verified</div>
//                         <div className="text-xs text-white bg-gray-700 px-2 py-1 rounded">Badge</div>
//                       </div>
//                     </div>
                    
//                     <div className="flex justify-end mt-4">
//                       <button 
//                         className="text-xs text-primary-cyan hover:text-cyan-300 transition-colors"
//                         onClick={() => window.open(cert.filePath, '_blank')}
//                       >
//                         View Details →
//                       </button>
//                     </div>
//                   </motion.div>
//                 ))}
//                 {/* View More Certifications card */}
//                 <motion.div 
//                   className="rounded-lg p-4 bg-white/3 backdrop-blur-sm border border-white/5 h-56 flex flex-col justify-center items-center cursor-pointer hover:bg-white/5 transition-colors"
//                   whileHover={{ y: -3 }}
//                   transition={{ duration: 0.2 }}
//                   onClick={handleViewMore}
//                 >
//                   <div className="text-center">
//                     <div className="text-3xl mb-2">+</div>
//                     <div className="text-lg font-semibold text-gray-400">View More</div>
//                     <div className="text-sm text-gray-500 mt-1">Additional Certifications</div>
//                   </div>
//                 </motion.div>
//               </div>
//             </motion.div>

//             <motion.div 
//               className="rounded-2xl p-6 bg-gradient-to-br from-gray-800/40 to-gray-900/30 backdrop-blur-lg border border-gray-700"
//               initial={{ opacity: 0, x: 20 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.5, delay: 0.1 }}
//             >
//               <h4 className="text-md font-semibold text-white">Filter & Export</h4>
//               <p className="text-gray-400 mt-2">Narrow down certificates and export to PDF for sharing.</p>

//               <div className="mt-4 space-y-3">
//                 <button className="w-full px-4 py-2 rounded-md bg-white/6 hover:bg-white/10 transition-colors text-left">
//                   All Certifications
//                 </button>
//                 <button className="w-full px-4 py-2 rounded-md bg-primary-cyan text-white font-medium hover:bg-primary-cyan/90 transition-colors flex items-center justify-center gap-2">
//                   <span>Export as PDF</span>
//                   <span>📄</span>
//                 </button>
//               </div>
//             </motion.div>
//           </div>
//         </motion.main>
//       </div>
//     </div>
//   );
// };

// export default Certifications;







import React from 'react';
import { motion } from 'framer-motion';

// ==============================
// Utility Helpers
// ==============================
const uid = (prefix = '') => `${prefix}${Math.random().toString(36).slice(2, 9)}`;

// ==============================
// Certification Data with Image Placeholders
// ==============================
const certifications = [
  { 
    id: uid('cert_'), 
    name: 'Data Science Mega-Course: #Build {120-Projects In 120-Days}', 
    issuer: 'Udemy', 
    year: 'Feb,2024', 
    tags: ['Machine-learning', 'Data-science'],
    filePath: '/pictures/certifications/1-datascience mega course.pdf',
    imagePath: 'https://wallpapers.com/images/high/data-science-conceptual-artwork-egm69qnw98ohlpeu.webp' // Add image path
  },
  { 
    id: uid('cert_'), 
    name: 'Build Generative AI Apps and Solutions with No-Code Tools', 
    issuer: 'Udemy', 
    year: 'Sept,2025', 
    tags: ['AI', 'No-Code', 'Generative AI'],
    filePath: '/pictures/certifications/2-Build Generative Al Apps and Solutions with No-Code.pdf',
    imagePath: 'https://cde.nus.edu.sg/wp-content/uploads/2024/06/article-06-turbocharging-the-energy-efficiency-of-AI-processors.jpg'
  },
  { 
    id: uid('cert_'), 
    name: 'The Bits and Bytes of Computer Networking', 
    issuer: 'Coursera - Google', 
    year: 'Sept,2023', 
    tags: ['Computer-Networks', 'Architecture'],
    filePath: '/pictures/certifications/3-bits and bytes.pdf',
    imagePath: 'https://as1.ftcdn.net/jpg/19/46/33/80/1000_F_1946338019_UCWr8qkOmxn8riAAw7nUg2OUtxbbLDQL.webp'
  },
  { 
    id: uid('cert_'), 
    name: 'TCP/IP and Advanced Topics', 
    issuer: 'Coursera', 
    year: 'Nov,2024', 
    tags: ['Cloud', 'Fundamentals'],
    filePath: '/pictures/certifications/4-TCP-IP.pdf',
    imagePath: 'https://as1.ftcdn.net/jpg/08/96/42/44/1000_F_896424440_ZD4I1v4PmzC068Y8iCLU3KY7WBxrQxQ5.jpg'
  },
  { 
    id: uid('cert_'), 
    name: 'Fundamentals of Network Communication', 
    issuer: 'Coursera', 
    year: 'Sep,2024', 
    tags: ['ML', 'Deep Learning'],
    filePath: '/pictures/certifications/5-Fundamentals of Network Communication.pdf',
    imagePath: 'https://as1.ftcdn.net/jpg/19/23/37/46/1000_F_1923374622_24ZrGkiMOpfBc4V4I7PHiqfYC4tlOdAA.jpg'
  },
  { 
    id: uid('cert_'), 
    name: 'Packet Switching Networks and Algorithms', 
    issuer: 'Coursera', 
    year: 'Nov,2024', 
    tags: ['Frontend', 'React'],
    filePath: '/pictures/certifications/6-packet switching.pdf',
    imagePath: 'https://as1.ftcdn.net/v2/jpg/04/12/20/64/1000_F_412206412_M7GWThrvGWR9gb4Agdgnkl4VcU17oO01.jpg'
  },
  { 
    id: uid('cert_'), 
    name: 'Digital Systems- From Logic Gates to Processors', 
    issuer: 'Coursera', 
    year: 'Nov,2024', 
    tags: ['Programming', 'Python'],
    filePath: '/pictures/certifications/7-Digital Systems- From Logic Gates to Processors.pdf',
    imagePath: 'https://img.freepik.com/free-photo/motherboard-circuit-background_23-2151733763.jpg'
  },
  { 
    id: uid('cert_'), 
    name: 'Peer-to-Peer Protocols and Local Area Networks.pdf', 
    issuer: 'coursera', 
    year: 'Nov,2024', 
    tags: ['ML', 'AI'],
    filePath: '/pictures/certifications/8-Peer-to-Peer Protocols and Local Area Networks.pdf',
    imagePath: 'https://t3.ftcdn.net/jpg/19/38/69/86/360_F_1938698607_W5xUZWgd6zNsE4O8uWAm66K3M152qbKb.jpg'
  }
];

// Image Placeholder Component for when image is missing
const CertificateImage = ({ imagePath, certName }) => {
  const [imageError, setImageError] = React.useState(false);

  if (imageError || !imagePath) {
    return (
      <div className="w-full h-32 bg-gradient-to-br from-gray-100 to-gray-200 rounded-lg flex items-center justify-center">
        <div className="text-center">
          <svg className="w-8 h-8 text-gray-400 mx-auto mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span className="text-xs text-gray-500">Certificate Preview</span>
        </div>
      </div>
    );
  }

  return (
    <img 
      src={imagePath} 
      alt={certName}
      className="w-full h-32 object-cover rounded-lg"
      onError={() => setImageError(true)}
    />
  );
};

// ==============================
// Main Certifications Component
// ==============================
const Certifications = () => {
  // Function to handle opening the new page
  const handleViewMore = () => {
    // Open the new page in the same window
    window.location.href = '/more-certifications';
  };

  return (
    <div className="relative min-h-screen py-12 px-4 sm:px-6 lg:px-8 overflow-hidden bg-white">
      {/* Animated Background Elements - Adjusted for white background */}
      <motion.div 
        className="absolute inset-0 bg-gradient-to-b from-gray-50 via-white to-gray-100"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      />
      
      <motion.div 
        className="absolute top-10 left-10 w-64 h-64 bg-primary-cyan/5 rounded-full blur-3xl"
        animate={{ 
          x: [0, 20, 0],
          y: [0, -20, 0],
          scale: [1, 1.1, 1]
        }}
        transition={{ 
          duration: 15,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      />
      
      <motion.div 
        className="absolute bottom-20 right-20 w-72 h-72 bg-purple-500/5 rounded-full blur-3xl"
        animate={{ 
          x: [0, -30, 0],
          y: [0, 30, 0],
          scale: [1, 1.2, 1]
        }}
        transition={{ 
          duration: 20,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      />
      
      <motion.div 
        className="absolute top-1/3 right-1/4 w-40 h-40 bg-blue-400/5 rounded-full blur-3xl"
        animate={{ 
          x: [0, 40, 0],
          y: [0, 40, 0],
        }}
        transition={{ 
          duration: 12,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      />

      <div className="max-w-7xl mx-auto relative z-10">
        <motion.header 
          className="text-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        > 
          <motion.div
            className="rounded-2xl backdrop-blur-lg border border-gray-200 p-6 bg-white/80 shadow-sm"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-2">
              <span className="bg-gradient-to-r from-primary-cyan to-blue-600 bg-clip-text text-transparent">Professional Certifications</span>
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              My verified certifications and continuous learning journey in technology.
            </p>
          </motion.div>
        </motion.header>

        <motion.main 
          initial={{ opacity: 0, y: 14 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.45 }}
        >
          <div className="grid grid-cols-1 gap-6">
            <motion.div 
              className="rounded-2xl p-6 bg-white shadow-lg border border-gray-200"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h3 className="text-lg font-bold text-gray-900">Certifications</h3>
              <p className="text-gray-500 mt-1">Verified certifications and credentials.</p>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {certifications.map((cert) => (
                  <motion.div 
                    key={cert.id} 
                    className="rounded-lg bg-gray-50 border border-gray-200 hover:border-primary-cyan/50 hover:shadow-md transition-all overflow-hidden flex flex-col"
                    whileHover={{ y: -3 }}
                    transition={{ duration: 0.2 }}
                  >
                    {/* Certificate Image Section */}
                    <div className="relative group">
                      <CertificateImage imagePath={cert.imagePath} certName={cert.name} />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
                        <button 
                          onClick={() => window.open(cert.filePath, '_blank')}
                          className="bg-white/90 backdrop-blur-sm text-gray-800 px-3 py-1 rounded-full text-xs font-medium shadow-lg"
                        >
                          View Certificate →
                        </button>
                      </div>
                    </div>

                    {/* Content Section */}
                    <div className="p-4 flex flex-col flex-grow">
                      <div className="flex items-start justify-between">
                        <div className="flex-1">
                          <div className="text-xs text-gray-500">{cert.issuer} • {cert.year}</div>
                          <div className="text-md font-semibold text-gray-900 mt-1 line-clamp-2">{cert.name}</div>
                          <div className="flex gap-2 mt-2 flex-wrap">
                            {cert.tags.map((tag, i) => (
                              <span key={i} className="text-xs px-2 py-1 bg-primary-cyan/10 text-primary-cyan rounded-full">
                                {tag}
                              </span>
                            ))}
                          </div>
                        </div>
                        <div className="flex flex-col items-end gap-2 ml-2">
                          <div className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded whitespace-nowrap">Verified</div>
                          <div className="text-xs text-gray-600 bg-gray-100 px-2 py-1 rounded whitespace-nowrap">Badge</div>
                        </div>
                      </div>
                      
                      <div className="flex justify-end mt-3 pt-2 border-t border-gray-200">
                        <button 
                          className="text-sm text-primary-cyan hover:text-blue-600 transition-colors font-medium flex items-center gap-1"
                          onClick={() => window.open(cert.filePath, '_blank')}
                        >
                          View Details
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </motion.div>
                ))}
                
                {/* View More Certifications card */}
                <motion.div 
                  className="rounded-lg bg-gray-50 border border-gray-200 h-full min-h-[380px] flex flex-col justify-center items-center cursor-pointer hover:bg-gray-100 transition-all hover:shadow-md"
                  whileHover={{ y: -3 }}
                  transition={{ duration: 0.2 }}
                  onClick={handleViewMore}
                >
                  <div className="text-center p-6">
                    <div className="w-16 h-16 bg-primary-cyan/10 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8 text-primary-cyan" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                    </div>
                    <div className="text-xl font-semibold text-gray-700 mb-2">View More</div>
                    <div className="text-sm text-gray-500">Additional Certifications</div>
                    <div className="text-xs text-gray-400 mt-4">Click to explore more →</div>
                  </div>
                </motion.div>
              </div>
            </motion.div>

            <motion.div 
              className="rounded-2xl p-6 bg-white shadow-lg border border-gray-200"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <h4 className="text-md font-semibold text-gray-900">Filter & Export</h4>
              <p className="text-gray-500 mt-2">Narrow down certificates and export to PDF for sharing.</p>

              <div className="mt-4 space-y-3">
                <button className="w-full px-4 py-2 rounded-md bg-gray-50 hover:bg-gray-100 transition-colors text-left text-gray-700 border border-gray-200">
                  All Certifications
                </button>
                <button className="w-full px-4 py-2 rounded-md bg-primary-cyan text-white font-medium hover:bg-blue-600 transition-colors flex items-center justify-center gap-2 shadow-sm">
                  <span>Export as PDF</span>
                  <span>📄</span>
                </button>
              </div>
            </motion.div>
          </div>
        </motion.main>
      </div>
    </div>
  );
};

export default Certifications;